import React, { useContext, useEffect, useState } from 'react';

import ListInfo from '@components/obsolete/ListInfo/ListInfo';
import ListInfoItem from '@components/obsolete/ListInfo/ListInfoItem';
import NavTitle from '@components/obsolete/NavTitle/NavTitle';
import { ApiContext } from '@api/api.tsx';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';
import useTranslation from '@hooks/i18n/useTranslation.tsx';
import EditPhoneSidebar from '@components/obsolete/EditPhoneSidebar/EditPhoneSidebar.tsx';
import { UserProfileOutDTO } from '@api/ringil-api.v2.tsx';
import { Clickable } from '@components/styles.tsx';
import { InputSwitch } from 'primereact/inputswitch';
import COText from '@app/pages/COText/COText.tsx';
import { Field } from '@components/framework/formfield/Field.tsx';
import { useTimezoneVisibility } from '@components/FigmaComponents/COTimezone.tsx';
import { useMenuMultiOpen, writeMenuMultiOpen } from '@app/layout/menuAccordionStore.ts';
import { useImprovedLayout, writeImprovedLayout } from '@app/layout/improvedLayoutStore.ts';
import { useMenuAttention, writeMenuAttention } from '@components/menu/menuAttentionStore.ts';
import { resetPanelPlacements, usePanelDockEnabled, writePanelDockEnabled } from '@components/panelDock/panelDockStore.ts';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';

export const MyProfile = () => {
  const { tr } = useTranslation();
  const { getProfileForCurrentUser } = useContext(ApiContext);
  const [state, setState] = useState<UserProfileOutDTO>();
  const { loggedUser } = useContext(AuthenticatedUserContext);
  useEffect(() => {
    load();
  }, []);
  const [visiblePhoneSidebar, setVisiblePhoneSidebar] = useState(false);
  const [timezoneVisible, setTimezoneVisible] = useTimezoneVisibility();
  const menuMultiOpen = useMenuMultiOpen();
  const improvedLayout = useImprovedLayout();
  const menuAttention = useMenuAttention();
  const panelDock = usePanelDockEnabled();

  const load = () => {
    getProfileForCurrentUser(data => {
      setState(data);
    });
  };
  return (
    <div>
      <NavTitle>
        <h2 className="h2-title p-m-0">{tr(`MyProfile.myProfile`, `Můj profil`)}</h2>
      </NavTitle>
      {state && (
        <>
          <ListInfo>
            <ListInfoItem title={tr(`MyProfile.firstName`, `Křestní jméno`)}>
              <p className="flex items-center">
                <small>{state.information.firstName}</small>
              </p>
            </ListInfoItem>
            <ListInfoItem title={tr(`MyProfile.lastNAme`, `Příjmení`)}>
              <p className="flex items-center">
                <small>{state.information.surname}</small>
              </p>
            </ListInfoItem>
            <ListInfoItem title={tr(`MyProfile.email`, `Email`)}>
              <p className="flex items-center">
                <small>{state.information.email}</small>
              </p>
            </ListInfoItem>
            <ListInfoItem title={tr(`MyProfile.phone`, `Telefon`)}>
              <p className="flex items-center gap-2">
                <small>{state.information.phone}</small>
                <Clickable>
                  <div onClick={() => setVisiblePhoneSidebar(true)}>{tr(`MyProfile.edit`, `upravit`)}</div>
                </Clickable>
              </p>
            </ListInfoItem>
            <ListInfoItem title={tr(`MyProfile.roles`, `Role`)}>
              <p className="flex items-center">
                <small>{loggedUser?.securityRoles.join(', ')}</small>
              </p>
            </ListInfoItem>
            <ListInfoItem title={tr(`MyProfile.company`, `Společnost`)}>
              <p className="flex items-center">
                <small>{loggedUser?.company}</small>
              </p>
            </ListInfoItem>
          </ListInfo>
          <div className={'flex flex-col mt-4'}>
            <Field label={tr('MyProfile.menuSections', 'Sekce v menu')}>
              <div className={'flex flex-row gap-2 '}>
                <InputSwitch checked={menuMultiOpen} onChange={e => writeMenuMultiOpen(e.target.value)} />
                <COText label={tr('MyProfile.menuKeepSectionsOpen', 'Ponechat otevřené i ostatní sekce')} />
              </div>
            </Field>
            <Field label={tr('MyProfile.menuAttention', 'Zvýraznění novinek v menu')}>
              <div className={'flex flex-row gap-2 '}>
                <InputSwitch checked={menuAttention} onChange={e => writeMenuAttention(e.target.value)} />
                <COText label={tr('MyProfile.menuAttentionDescription', 'Upozorňovat na nové položky v menu')} />
              </div>
            </Field>
            <Field label={tr('MyProfile.panelDock', 'Přesouvání a minimalizace panelů')}>
              <div className={'flex flex-row items-center gap-2 '}>
                <InputSwitch checked={panelDock} onChange={e => writePanelDockEnabled(e.target.value)} />
                <COText label={tr('MyProfile.panelDockDescription', 'Boční panely, např. asistenta, lze přesunout, uvolnit jako okno nebo minimalizovat')} />
                {/* Puts every panel back docked right at its default size — for anyone who has lost track
                    of where they left one, or just wants the defaults back. */}
                <RingilButton mode={'text-only'} label={tr('MyProfile.panelDockReset', 'Obnovit výchozí umístění')} onClick={resetPanelPlacements} />
              </div>
            </Field>
            <Field label={tr('MyProfile.improvedLayout', 'Vylepšený layout Ringilu')}>
              <div className={'flex flex-row gap-2 '}>
                <InputSwitch checked={improvedLayout} onChange={e => writeImprovedLayout(e.target.value)} />
                <COText label={tr('MyProfile.improvedLayoutDescription', 'Omezit šířku obsahu (jinak se obsah roztáhne přes celou šířku)')} />
              </div>
            </Field>
            <Field label={tr('MyProfile.showTimezone', 'Show timezone')}>
              <div className={'flex flex-row gap-2 '}>
                <InputSwitch checked={timezoneVisible} onChange={e => setTimezoneVisible(e.target.value)} />
                <COText label={tr('MyProfile.timezoneVisible', 'Timezone visible')} />
              </div>
            </Field>
          </div>
        </>
      )}

      {state && (
        <EditPhoneSidebar
          visible={visiblePhoneSidebar}
          onHide={() => setVisiblePhoneSidebar(false)}
          phoneNumber={state.information.phone}
          onComplete={() => {
            load();
            setVisiblePhoneSidebar(false);
          }}
        />
      )}
    </div>
  );
};
